
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '@/hooks/useAnalytics';

const HeaderV5 = () => {
  const navigate = useNavigate();
  const {
    trackCTAClick,
    trackOnboardingStart
  } = useAnalytics();

  const handleGetEarlyAccess = () => {
    trackCTAClick('header');
    trackOnboardingStart();
    navigate('/early-access');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-white/95 via-purple-100/90 to-purple-600/90 backdrop-blur-sm border-b border-white/10">
      <div className="container max-w-7xl mx-auto px-4 py-5">
        <div className="flex justify-between items-center">
          {/* Logo Section - Optimized WebP with PNG fallback */}
          <div className="flex items-center">
            <img 
              alt="Show Up! - Don't Overthink Habit Tracker Logo" 
              className="h-24 w-auto drop-shadow-lg object-contain" 
              src="/lovable-uploads/9b33affd-d213-4c54-b7d2-a74e48fe5ff5.png"
              loading="eager"
              decoding="sync"
              width="96"
              height="96"
            />
          </div>
          
          {/* CTA Button */}
          <button 
            onClick={handleGetEarlyAccess} 
            className="bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-black px-6 py-3 rounded-xl shadow-lg hover:scale-105 transition-all duration-300 text-sm md:text-base"
          >
            Get Early Access
          </button>
        </div>
      </div>
    </header>
  );
};

export default HeaderV5;
